import { Suspense } from 'react'

import { useCompany } from '@shared-admin-kit/core'

import PT from 'prop-types'

import { useGlobalNotifications } from '../../providers/global-notifications-provider'
import GlobalNotification from '../global-notification'
import MainLoader from '../main-loader'

import TopNav from './components/top-nav'
import Styled from './layout.styles'

// function WrappedRoute(props) {
//   return (
//     <RouteComponent
//       {...props}
//       wrap={(content) => (
//         <Suspense fallback={<MainLoader />}>
//           {content}
//         </Suspense>
//       )}
//       loader={<MainLoader />}
//     />
//   );
// }

function Layout({ children }) {
  const { isProjectLoading } = useCompany()
  const { notifications } = useGlobalNotifications()

  return (
    <>
      <Styled.TopNavWrap className='shrink-0 grow-0'>
        <TopNav />
        {(notifications || []).length > 0 &&
          notifications.map(({ uuid, notification }) => (
            <GlobalNotification key={uuid} uuid={uuid} notification={notification} />
          ))}
      </Styled.TopNavWrap>

      <Styled.Content className='min-h-0 flex flex-1'>
        <Suspense fallback={<MainLoader />}>{isProjectLoading ? <MainLoader /> : children}</Suspense>
      </Styled.Content>
    </>
  )
}

Layout.defaultProps = {
  children: null,
}

Layout.propTypes = {
  children: PT.node,
}

export default Layout
